import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
@UntilDestroy()
@Component({
  selector: 'j-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss']
})
export class DateInputComponent {
  @Input() disabled: boolean;
  //@Input('control') externalControl: FormControl;
  @Input() control: FormControl;
  @Input() containerClassName = '';
  @Input() placeholder = '';
  // @Input() width = 185.2;
  @Input() dateFormat = 'dd/MM/YYYY';
  @Input() onlyFuture = false;
  @Input() showTime:(object | boolean) = false;
  @Input() allowClear: boolean = true;
  internalControl: FormControl;
  model: any;
  locale;

  constructor(private translate: TranslateService) {
    /* this.locale = {
      "lang": {
        "locale": "en_US",
        "placeholder": "Select date",
        "rangePlaceholder": ["Start date", "End date"],
        "today": "Today",
        "now": "Now",
        "backToToday": "Back to today",
        "ok": "OK",
        "clear": "Clear",
        "month": "Month",
        "year": "Year",
        "timeSelect": "Select time",
        "dateSelect": "Select date",
        "monthSelect": "Choose a month",
        "yearSelect": "Choose a year",
        "decadeSelect": "Choose a decade",
        "yearFormat": "YYYY",
        "dateFormat": "M/D/YYYY",
        "dayFormat": "D",
        "dateTimeFormat": "M/D/YYYY HH:mm:ss",
        "monthFormat": "MMMM",
        "monthBeforeYear": true,
        "previousMonth": "Previous month (PageUp)",
        "nextMonth": "Next month (PageDown)",
        "previousYear": "Last year (Control + left)",
        "nextYear": "Next year (Control + right)",
        "previousDecade": "Last decade",
        "nextDecade": "Next decade",
        "previousCentury": "Last century",
        "nextCentury": "Next century",

      },
      "timePickerLocale": {
        "placeholder": "Select time"
      },
      "dateFormat": "YYYY-MM-DD",
      "dateTimeFormat": "YYYY-MM-DD HH:mm:ss",
      "weekFormat": "YYYY-wo",
      "monthFormat": "YYYY-MM"
    } */
  }
 
  // get style() {
  //   return {
  //     width: `${this.width}px`
  //   }
  // }

  disabledDate = (currDate: Date) => {
    if (this.onlyFuture === true) {
      const date = new Date();
      date.setHours(0,0,0,0);
      return date.getTime() > currDate.getTime();
    }
    return false;
  }
}
